<div class="spinner spinner--{{size}}">
  <div class="spinner__ring"></div>
</div>
